// extracted by mini-css-extract-plugin
module.exports = {"NavLinks":"NavLinks_NavLinks__1Kbci","active":"NavLinks_active__18Vu6"};